import React, { useContext, useMemo } from "react";
import clsx from "clsx";

import { Context } from "../../../../teacherStore";
import { getStudentAnswersByQuestion } from "../../../../libs/ActiveLearning";
import styles from "../ActiveLearningLessonAnswerData.module.scss";

interface ILesson11Pros {
  materialCode: string;
  lessonNo: number;
}

export const Lesson11: React.FC<ILesson11Pros> = ({
  materialCode,
  lessonNo,
}) => {
  const { state } = useContext(Context);
  const activeLearningStudentAnswers = state.active_learning_student_answers;

  const answersL11I1Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      1,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL11I2Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      2,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL11I3Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      3,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL11I4Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      4,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  return (
    <div className={styles.lesson}>
      <p className={styles.title}>
        Lesson{lessonNo < 10 ? `0${lessonNo}` : lessonNo}{" "}
        自分の成長と未来について考えよう
      </p>
      <div className={styles.inner}>
        <div className={styles.work}>
          <p className={styles.no}>WORK01</p>
          <div className={styles.question}>
            <p className={styles.heading}>
              自分が興味・関心を持って取り組めたことや学びになったことを振り返ろう。
            </p>
            <p className={clsx(styles.answer, styles.high)}>{answersL11I1Q1}</p>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK02</p>
          <div className={styles.question}>
            <p className={styles.heading}>改善点を振り返ろう。</p>
            <p className={clsx(styles.answer, styles.high)}>{answersL11I2Q1}</p>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK03</p>
          <div className={styles.question}>
            <p className={styles.heading}>
              成長できたと思う部分を考えてみよう。
            </p>
            <p className={clsx(styles.answer, styles.high)}>{answersL11I3Q1}</p>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK04</p>
          <div className={styles.question}>
            <p className={styles.heading}>
              今回学んだことで分かった自分の強みや、今後やってみたい、伸ばしていきたいと思うことを考えよう。
            </p>
            <p className={clsx(styles.answer, styles.high)}>{answersL11I4Q1}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Lesson11;
